import { render } from "./KubernetesFirstPod.vue?vue&type=template&id=12283ab8"
import script from "./KubernetesFirstPod.vue?vue&type=script&lang=js"
export * from "./KubernetesFirstPod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__